export enum SailingTypesEnum {
    Generic = 1,
    Freight = 2,
    Tourism = 3,
}
